import React from "react";
import { Badge } from "@mui/icons-material";
import { dashboardMetrics, trackerSignals } from "../../../../../data/workspaceData";
import { MetricCard, SectionHeader } from "../../../common/WorkspaceChrome";

export function OverviewTab({ focusQueue, openFocusItem, completeFocusItem }) {
  return (
    <>
      <section className="metrics-grid" aria-label="Workspace metrics">
        {dashboardMetrics.map((item) => (
          <MetricCard item={item} key={item.label} />
        ))}
      </section>

      <div className="content-grid">
        <section className="panel">
          <SectionHeader
            eyebrow="Focus"
            title="Today's command center"
            text="Founder and manager view for the most important decisions."
          />
          <div className="focus-list">
            {focusQueue.map((item) => (
              <article key={item.title}>
                <div>
                  <strong>{item.title}</strong>
                  <span>{item.meta}</span>
                </div>
                <div className="dashboard-action-row">
                  <small className={item.state === "Completed" ? "done" : ""}>{item.state}</small>
                  <button onClick={() => openFocusItem(item)} type="button">Open</button>
                  <button disabled={item.state === "Completed"} onClick={() => completeFocusItem(item.title)} type="button">
                    Done
                  </button>
                </div>
              </article>
            ))}
          </div>
        </section>
        <section className="panel">
          <SectionHeader
            eyebrow="Activity"
            title="Tracker and work signals"
            text="Windows and Mac trackers feed attendance, active app, idle time, and task context."
          />
          <div className="signal-list">
            {trackerSignals.map((signal) => (
              <div key={signal}>
                <Badge fontSize="small" />
                <span>{signal}</span>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}
